module.exports = __webpack_public_path__ + "step1.ec20a59497d40cce3caab88a2490b586.png";